import { getAcademyUrlPublic, getAppMarketplaceUrl, getCMSUrlPublic, getCommunityUrlPublic, getDataSyncAppCollectionUrl, getDataUrlPublic, getDevelopersAndApiDocsBaseUrl, getDevelopersApiDocsUrl, getDevelopersQuickStartGuideUrl, getKBEmbedCTAUrlPublic, getKBImportToolUrlPublic, getKBMembershipsUrlPublic, getKBShareFormsUrlPublic, getKBTrackingCodeUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingPricingUrlPublic, getMarketingUrlPublic, getMembershipsExamplesUrl, getMicrositesExamplesUrl, getNonprofitsUrlPublic, getSalesUrlPublic, getSecurityAndComplianceUrl, getServiceUrlPublic, getSmartCrmAIUrlPublic, getSmartCrmPricingUrlPublic, getSolutionsMarketplaceUrl, getStartupsUrlPublic, getTemplatesMarketplaceUrl, getWebsiteMigrationUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { getCreateABundleUrl, getProductsAndServicesCatalogUrl } from 'pricing-pages-lib/utils/urls';
import { trackClickedLink } from '../../v2/utils/tracking/trackingEventUtils';
import { NavItemEnum } from '../routing/NavItems';
import { TRACKING_SOURCES } from '../../v2/constants/tracking/TrackingSources';
export const FaqsConfig = {
  [NavItemEnum.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'marketing.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'marketing.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'marketing.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'marketing.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SALES]: [{
    questionKey: 'sales.whatIsSalesHub411',
    getHref: () => getSalesUrlPublic()
  }, {
    questionKey: 'sales.whatIsFreeVsPaid411'
  }, {
    questionKey: 'sales.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'sales.salesVsService411'
  }, {
    questionKey: 'sales.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'sales.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'sales.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'sales.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'sales.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SERVICE]: [{
    questionKey: 'service.whatIsServiceHub411',
    getHref: () => getServiceUrlPublic()
  }, {
    questionKey: 'service.whatIsFreeVsPaid411'
  }, {
    questionKey: 'service.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'service.salesVsService411'
  }, {
    questionKey: 'service.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'service.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'service.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'service.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'service.whenEligibleForNewPricing'
  }],
  [NavItemEnum.DATA]: [{
    questionKey: 'data.faq1',
    getHref: () => getDataUrlPublic()
  }, {
    questionKey: 'data.faq2'
  }, {
    questionKey: 'data.faq3',
    isJSX: false
  }, {
    questionKey: 'data.faq4'
  }, {
    questionKey: 'data.faq5',
    getHref: () => getDataSyncAppCollectionUrl()
  }, {
    questionKey: 'data.faq6',
    isJSX: false
  }, {
    questionKey: 'data.faq7',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'data.faq7',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'data.faq8',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'data.faq8',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }],
  [NavItemEnum.FREE]: [{
    questionKey: 'free.whatAreLimits411',
    getPassedInOptions: () => ({
      marketingHref: getMarketingPricingUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatAreLimits411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.emailIntegration411'
  }, {
    questionKey: 'free.howManyContacts411',
    isExternalLink: true,
    getHref: () => {
      return getMarketingPricingUrlPublic();
    }
  }, {
    questionKey: 'free.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SUITE]: [{
    questionKey: 'crmSuite.whatIsCrmSuite',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'crmSuite.whenEligibleForNewPricing'
  }],
  [NavItemEnum.COMMERCE]: [],
  [NavItemEnum.CONTENT]: [{
    questionKey: 'content.whatIsContentHub',
    getHref: () => getCMSUrlPublic(true)
  }, {
    questionKey: 'content.existingWebsite',
    getPassedInOptions: () => ({
      appMarketPlaceHref: getAppMarketplaceUrl(),
      shareFormsHref: getKBShareFormsUrlPublic(),
      embedCTAHref: getKBEmbedCTAUrlPublic(),
      trackingCodeHref: getKBTrackingCodeUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.existingWebsite',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.micrositeCustomPortal',
    getPassedInOptions: () => ({
      websiteBuilderHref: getCMSUrlPublic(true),
      micrositesExamplesHref: getMicrositesExamplesUrl(),
      membershipsHref: getKBMembershipsUrlPublic(),
      membershipsExamplesHref: getMembershipsExamplesUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.micrositeCustomPortal',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.trainDevelopersAndIT',
    getPassedInOptions: () => ({
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiHref: getDevelopersAndApiDocsBaseUrl(),
      hostingAndSecurityHref: getSecurityAndComplianceUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.trainDevelopersAndIT',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.migrateExistingWebsite',
    getPassedInOptions: () => ({
      templatesHref: getTemplatesMarketplaceUrl(),
      importToolHref: getKBImportToolUrlPublic(),
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiDocsHref: getDevelopersApiDocsUrl(),
      solutionsPartnerHref: getSolutionsMarketplaceUrl(),
      websiteMigrationHref: getWebsiteMigrationUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.migrateExistingWebsite',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whatSupport',
    getPassedInOptions: () => ({
      langHref: getLanguagesUrlPublic(),
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.whatSupport',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whatDiscounts',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-contentpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-contentpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.whatDiscounts',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SMART_CRM]: [{
    questionKey: 'smart-crm.whatIsSmartCrm'
  }, {
    questionKey: 'smart-crm.howIsAIUsed',
    getPassedInOptions: () => ({
      breezeLink: getSmartCrmAIUrlPublic(),
      breezePricingPageLink: getSmartCrmPricingUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'smart-crm.howIsAIUsed',
          url,
          type: 'internal',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'smart-crm.howDoesSmartCrmWork'
  }, {
    questionKey: 'smart-crm.whatTypeOfSupport'
  }],
  [NavItemEnum.HUBSPOT_CREDITS]: [{
    questionKey: 'hubspot-credits.faq1'
  }, {
    questionKey: 'hubspot-credits.faq2',
    getPassedInOptions: () => ({
      psHref: getProductsAndServicesCatalogUrl('#HubSpotCreditsRateSheet'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'hubspot-credits.faq2',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'hubspot-credits.faq3'
  }, {
    questionKey: 'hubspot-credits.faq4'
  }]
};